import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=ts&generic=U%20extends%20string%7Cnumber"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=ts&generic=U%20extends%20string%7Cnumber"

const __exports__ = script;

export default __exports__